import { HeroSection } from "./components/HeroSection";
import { KpiGrid } from "./components/KpiGrid";
import { AnalyticsCharts } from "./components/AnalyticsCharts";
import { AiInsightsCard } from "./components/AiInsightsCard";
import { TeamwiseCandidateProfiles } from "./components/TeamwiseCandidateProfiles";
import { PendingTasks } from "./components/PendingTasks";
import { RecentActivities } from "./components/RecentActivities";
import { DashboardFooter } from "./components/DashboardFooter";

export default function AdminDashboard() {
  return (
    <div className="p-4 lg:p-8 max-w-[1920px] mx-auto space-y-8 ">
      {/* <HeroSection /> */}
      <KpiGrid />
      <TeamwiseCandidateProfiles />
    </div>
  );
}
